module.exports = __webpack_public_path__ + "img/Kultapossu-III.779cdbb8.png";